module.exports = __webpack_public_path__ + "static/media/photo41.c810e68f.jpg";